module.exports = __webpack_public_path__ + "static/img/h6-3.264207a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h6-3.png
// module id = weze
// module chunks = 1